//@constants
const { accountValidationRules } = require('utilities/accessHelperConditions/accounts');
const { cardValidationRules } = require('utilities/accessHelperConditions/cards');
const sections = Object.assign({}, accountValidationRules, cardValidationRules);

function allowAccess(sectionId, params, history, redirect = true) {  //Set in false when using in moreOptionsButton
    if (!sections[sectionId]){  //Return true, when there isn't validation rule.
        return true;
    }

    const accessValidator = sections[sectionId]['validator']; //Getting validationRule
    if (accessValidator(params)) {
        return true;
    } else {
        if (redirect){
            history.push(sections[sectionId]['redirectURL']);
        } else {
            return false;
        }
    }
}

module.exports = { allowAccess };
